import { Injectable } from '@angular/core';
import { ApiService } from '../..';

@Injectable()
export class canhbaovanhhanhService {

  constructor(public api: ApiService) { }
  APIURL_Chung = "api/ExcuteOracle"
  /*******************Lấy báo cáo thống kê***********************/
  public canhbaovanhanh_thongkecanhbao(danhmucid, mataikhoan) {
    var param = {
      "config": '{"namesql":"PKG_BC_CANHBAOVANHANH.THONGKECANHBAO","connstr":"Amiss42"}',
      "para": '{"v_Danhmucid":"' + danhmucid + '","v_mataikhoan":"' + mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }

  thongkecanhbao_exportExcel(danhmucid, mataikhoan, tendonvi, tenchucnang, noidungbaocao, thoigian) {
    let columns = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "name", "label": "Tên Đơn Vị", "horizontalalignment": "left" },
      { "name": "count_u", "label": "Cảnh báo điện áp", "horizontalalignment": "center" },
      { "name": "count_i", "label": "Cảnh báo dòng điện", "horizontalalignment": "right" },
      { "name": "count_cos", "label": "Cảnh báo cos φ", "horizontalalignment": "right" },
      { "name": "count_p", "label": "Cảnh báo công suất", "horizontalalignment": "right" },
      { "name": "count_angle", "label": "Cảnh báo góc lệch pha", "horizontalalignment": "right" },
      { "name": "count_time", "label": "Cảnh báo thời gian", "horizontalalignment": "right" },
      { "name": "count_sl", "label": "Cảnh báo sản lượng", "horizontalalignment": "right" }
    ];


    var param = {
      config: JSON.stringify({ namesql: "PKG_BC_CANHBAOVANHANH.EXCEL_THONGKECANHBAO" }),
      para: JSON.stringify({
        v_Danhmucid: danhmucid,
        v_mataikhoan: mataikhoan
      }),
      title: tenchucnang,
      header: tendonvi + "," + "Ngày xuất dữ liệu: " + thoigian,
      sheets: "tenchucnang",
      columns: columns,
      filename: "thongkecanhbao.xls",
      data: ""
    };
    var filename = "thongkecanhbao.xls";
    return this.api.downloadFile("api/ExportExcel", param, filename);
  }
  /*******************Cảnh báo chưa kiểm tra xử lý************************************* */
  public canhbaovanhanh_loadloaicanhbao() {
    var param = {
      "config": '{"namesql":"PKG_BC_CANHBAOVANHANH.LOAICANHBAO_VH","connstr":"Amiss42"}',
      "para": '{}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  public canhbaovanhanh_GetChuaKiemTraXuLy(danhmucid, loaikkhachhang, loaicanhbao, locgiatritu, locgiatriden, mataikhoan, pageNum, numRecs) {
    var param = {
      "config": '{"namesql":"PKG_BC_CANHBAOVANHANH.GETCHUAKIEMTRAXULY","connstr":"Amiss42"}',
      "para": '{"v_Danhmucid":"' + danhmucid + '","v_loaikhachhang":"' + loaikkhachhang + '","v_loaicanhbao":"' + loaicanhbao + '","v_locgiatritu":"' + locgiatritu + '","v_locgiatriden":"' + locgiatriden + '","v_mataikhoan":"' + mataikhoan + '","v_pagenum":"' + pageNum + '","v_numrecs":"' + numRecs + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }

  public canhbaovanhanh_GetNotificationCB(danhmucid) {
    var param = {
      "config": '{"namesql":"PKG_BC_CANHBAOVANHANH.GET_NOTIFICATION_CANHBAO","connstr":"Amiss42"}',
      "para": '{"v_Danhmucid":"' + danhmucid + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }

  ChuaKiemTraXuLy_exportExcel(danhmucid, loaikkhachhang, loaicanhbao, locgiatritu, locgiatriden, mataikhoan, tendonvi, tenchucnang, noidungbaocao, thoigian) {
    let columns = [
      { "name": "rnum", "label": "STT", "horizontalalignment": "center" },
      { "name": "madiemdo", "label": "Mã Điểm Đo", "horizontalalignment": "left" },
      { "name": "name", "label": "Tên khách hàng", "horizontalalignment": "left" },
      { "name": "tu", "label": "TU", "horizontalalignment": "center" },
      { "name": "ti", "label": "Ti", "horizontalalignment": "center" },
      { "name": "tgcanhbao", "label": "Thời gian xảy ra cảnh báo", "horizontalalignment": "center" },
      { "name": "tgcanhbaogannhat", "label": "Thời điểm cảnh báo gần nhất", "horizontalalignment": "right" },
      { "name": "tencanhbao", "label": "Phân loại cảnh báo", "horizontalalignment": "right" },
      { "name": "noidungcanhbao", "label": "Nội dung cảnh báo", "horizontalalignment": "right" },
      { "name": "tongthoigian", "label": "Tổng thời gian", "horizontalalignment": "right" },

    ];
    let para: any = JSON.stringify({
      v_Danhmucid: danhmucid,
      v_loaikhachhang: loaikkhachhang,
      v_loaicanhbao: loaicanhbao,
      v_locgiatritu: locgiatritu,
      v_locgiatriden: locgiatriden,
      v_mataikhoan: mataikhoan
    });
    let config = JSON.stringify({ namesql: "PKG_BC_CANHBAOVANHANH.EXCEL_CHUAKIEMTRAXULY", connstr: "Amiss42" });
    return this.api.exportExcel("", columns, para, config, tendonvi, tenchucnang, noidungbaocao, thoigian);
  }
  public ChuaKiemTraXuLy_saveDaXemXet(meterid, loaicanhbao, userid) {
    var param = {
      "config": '{"namesql":"PKG_BC_CANHBAOVANHANH.UPDATEDAXEMXET","connstr":"Amiss42"}',
      "para": '{"v_meterid":"' + meterid + '","v_loaicanhbao":"' + loaicanhbao + '","v_userid":"' + userid + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  /*******************Cảnh báo đang xử lý************************************* */
  public canhbaovanhanh_GetCanhBaoDangXuLy(danhmucid, trangthaikhacphuc, mataikhoan, pageNum, numRecs) {
    var param = {
      "config": '{"namesql":"PKG_BC_CANHBAOVANHANH.GETCANHBAODANGXULY","connstr":"Amiss42"}',
      "para": '{"v_Danhmucid":"' + danhmucid + '","v_trangthaikhacphuc":"' + trangthaikhacphuc + '","v_mataikhoan":"' + mataikhoan + '","v_pagenum":"' + pageNum + '","v_numrecs":"' + numRecs + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  DangTraXuLy_exportExcel(danhmucid, trangthaikhacphuc, mataikhoan, tendonvi, tenchucnang, noidungbaocao, thoigian) {
    let columns = [
      { "name": "rnum", "label": "STT", "horizontalalignment": "center" },
      { "name": "madiemdo", "label": "Mã Điểm Đo", "horizontalalignment": "left" },
      { "name": "name", "label": "Tên Đơn Vị", "horizontalalignment": "left" },
      { "name": "tu", "label": "TU", "horizontalalignment": "center" },
      { "name": "ti", "label": "Ti", "horizontalalignment": "center" },
      { "name": "tgcanhbao", "label": "Thời gian xảy ra cảnh báo", "horizontalalignment": "center" },
      { "name": "tgcanhbaogannhat", "label": "Thời điểm cảnh báo gần nhất", "horizontalalignment": "right" },
      { "name": "tencanhbao", "label": "Phân loại cảnh báo", "horizontalalignment": "right" },
      { "name": "noidungcanhbao", "label": "Nội dung cảnh báo", "horizontalalignment": "right" },
      { "name": "tongthoigian", "label": "Tổng thời gian", "horizontalalignment": "right" },

    ];
    let para: any = JSON.stringify({
      v_Danhmucid: danhmucid,
      v_trangthaikhacphuc: trangthaikhacphuc,
      v_mataikhoan: mataikhoan
    });
    let config = JSON.stringify({ namesql: "PKG_BC_CANHBAOVANHANH.EXCEL_DANGKIEMTRAXULY", connstr: "Amiss42" });
    return this.api.exportExcel("", columns, para, config, tendonvi, tenchucnang, noidungbaocao, thoigian);
  }
  public canhbaovanhanh_LapKeHoach(meterid_cb, dalapkehoach, userid) {
    var param = {
      "config": '{"namesql":"PKG_BC_CANHBAOVANHANH.SAVELAPKEHOACH","connstr":"Amiss42"}',
      "para": '{"v_meterid":"' + meterid_cb + '","v_dalapkehoach":"' + dalapkehoach + '","v_userid":"' + userid + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }

  public canhbaovanhanh_XacNhanCanhBao(meterid_cb, dalapkehoach, userid, noidung, ngaycanhbao, ngayxuly, sanluong, sotien, ghichu) {
    var param = {
      "config": '{"namesql":"PKG_BC_CANHBAOVANHANH.SAVEXACNHANCANHBAO","connstr":"Amiss42"}',
      "para": '{"v_meterid":"' + meterid_cb + '","v_dalapkehoach":"' + dalapkehoach + '","v_userid":"' + userid + '","v_noidung":"' + noidung + '","v_ngaycanhbao":"' + ngaycanhbao + '","v_ngayxuly":"' + ngayxuly + '","v_sanluong":"' + sanluong + '","v_sotien":"' + sotien + '","v_ghichu":"' + ghichu + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }

  /****Cảnh báo đã xử lý*****/
  public canhbaovanhanh_GetCanhBaoDaXuLy(danhmucid, tungay, denngay, mataikhoan, pageNum, numRecs) {
    var param = {
      "config": '{"namesql":"PKG_BC_CANHBAOVANHANH.GETCANHBAODAXULY","connstr":"Amiss42"}',
      "para": '{"v_Danhmucid":"' + danhmucid + '","v_tungay":"' + tungay + '","v_denngay":"' + denngay + '","v_mataikhoan":"' + mataikhoan + '","v_pagenum":"' + pageNum + '","v_numrecs":"' + numRecs + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  DaXuLy_exportExcel(danhmucid, tungay, denngay, mataikhoan, pageNum, numRecs, tendonvi, tenchucnang, noidungbaocao, thoigian) {
    let columns = [
      { "name": "rnum", "label": "STT", "horizontalalignment": "center" },
      { "name": "madiemdo", "label": "Mã Điểm Đo", "horizontalalignment": "left" },
      { "name": "tenkhachhang", "label": "Tên điểm đo", "horizontalalignment": "left" },
      { "name": "dienluc", "label": "Điện lực", "horizontalalignment": "left" },
      { "name": "tennguoidung", "label": "Họ tên người cập nhật", "horizontalalignment": "left" },
      { "name": "noidung", "label": "Nội dung cập nhật", "horizontalalignment": "left" },
      { "name": "ngaycanhbao", "label": "Ngày phát hiện sự cố", "horizontalalignment": "center" },
      { "name": "ngayxuly", "label": "Ngày xử lý", "horizontalalignment": "center" },
      { "name": "sanluong", "label": "Sản lượng truy thu", "horizontalalignment": "right" },
      { "name": "sotien", "label": "Số tiền truy thu", "horizontalalignment": "right" },
      { "name": "ghichu", "label": "Ghi chú", "horizontalalignment": "left" },

    ];
    let para: any = JSON.stringify({
      v_Danhmucid: danhmucid,
      v_tungay: tungay,
      v_denngay: denngay,
      v_mataikhoan: mataikhoan,
      v_pagenum: pageNum,
      v_numrecs: numRecs
    });
    let config = JSON.stringify({ namesql: "PKG_BC_CANHBAOVANHANH.GETCANHBAODAXULY", connstr: "Amiss42" });
    return this.api.exportExcel("", columns, para, config, tendonvi, tenchucnang, noidungbaocao, thoigian);
  }
  public xacnhan_canhbao(danhmucid) {
    var param = {
      "config": '{"namesql":"PKG_BC_CANHBAOVANHANH.Update_NOTIFICATION_CANHBAO","connstr":"Amiss42"}',
      "para": '{"v_Danhmucid":"' + danhmucid + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/canh-bao/canh-bao-van-hanh/canhbaovanhanh.service.ts